import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaEntregaFormGroup = ({ iError, iTouched, fIsSubmitting, disabled }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC ENTREGA' htmlFor='inputDate-fechaEntrega' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='fechaEntrega'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting || disabled}
              id='inputDate-fechaEntrega'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEntregaFormGroup)
